(function(){
  function move(){
    // Only act on mobile widths
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var cards = document.querySelectorAll('.card--product, .product-card, [data-product-card]');
    var moved = 0, overlays = 0;

    cards.forEach(function(card){
      var media = card.querySelector('.card__media, .product-card__media, [class*="media"]');
      var info  = card.querySelector('.card__information, .product-card__info, .card__content, [class*="info"]');
      if(!media || !info) return;

      // Find any “overlay” CTA inside the image
      var qa = media.querySelector(
        '.quick-add, .quick-add__submit, .card__mobile-actions, .card__actions, .card__cta, .product-card__buttons, ' +
        '[data-quick-add], [class*="quick-add"], [class*="add-to-cart"], [class*="cta"], button[name="add"], form[action*="/cart/add"]'
      );

      if (qa) {
        overlays++;
        if (!qa.dataset.moved) {
          qa.dataset.moved = '1';
          // neutralize overlay positioning
          qa.style.cssText += 'position:static!important;inset:auto!important;transform:none!important;margin-top:8px!important;';
          // place CTA right after the info block (title/price)
          info.insertAdjacentElement('afterend', qa);
          moved++;
        }
      }

      // Fallback: if theme already has a bottom actions container, force show it
      var bottom = card.querySelector('.card__mobile-actions, .card__footer, .product-card__buttons, form[action*="/cart/add"]');
      if (bottom) {
        bottom.style.display = '';
        bottom.style.cssText += 'position:static!important;margin-top:8px!important;';
      }
    });

    console.log('[GG] cards:', cards.length, 'overlays found:', overlays, 'moved:', moved);
  }

  document.addEventListener('DOMContentLoaded', move);
  document.addEventListener('shopify:section:load', function(){ move(); });

  // You can run window._gg_debug() from the console to re-run and see logs
  window._gg_debug = move;
})();

